import { render, staticRenderFns } from "./commsManager.vue?vue&type=template&id=46c09fcd&lang=pug"
import script from "./commsManager.vue?vue&type=script&lang=js"
export * from "./commsManager.vue?vue&type=script&lang=js"
import style0 from "./commsManager.vue?vue&type=style&index=0&id=46c09fcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports